<form #domainForm="ngForm" class="form-horizontal" (ngSubmit)="domainForm.valid && isScanValid && submit()">
    <div class="mon-dialog-header">
        <page-header
            [subHeader]="domain?.url || ('Add a new domain' | translate)"
            [header]="domain?.id ? ('Edit Domain' | translate) : ('New Domain' | translate)">
        </page-header>
    </div>

    <div class="mon-dialog-body-with-footer bg-body inner-t-medium">
        <!-- Navigation buttons -->
        <div class="row">
            <div class="col-48 px-12 pb-2">
                <a class="btn" (click)="scrollTo('form_domain_domain_detail')" translate>Domain Detail</a>
                <a class="btn" (click)="scrollTo('form_domain_scan')" translate>Scan</a>
                <a class="btn" (click)="scrollTo('form_domain_features')" translate>Features</a>
                <a class="btn" (click)="scrollTo('form_domain_groups')" *ngIf="domain?.id && domain.id > 0" translate>Groups</a>
                <a class="btn" (click)="scrollTo('form_domain_users')" translate>Users</a>
                <hr class="mt-2">
            </div>
        </div>

        <mon-spinner [loading]="loading">
            <div class="row px-9" *ngIf="!loading">
                <!-- Domain Detail Section -->
                <div class="col-48">
                    <div class="card panel-monsido-card" id="form_domain_domain_detail">
                        <div class="card-header d-flex">
                            <h2 class="font-weight-300" translate>Domain Details</h2>
                        </div>
                        <div class="card-body">
                            <form-domain-detail [domain]="domain" (cmsValidityChange)="isCMSValid = $event"></form-domain-detail>
                        </div>
                    </div>
                </div>

                <!-- Scan Section -->
                <div class="col-48 mt-3">
                    <div class="card panel-monsido-card" id="form_domain_scan">
                        <div class="card-header d-flex">
                            <h2 class="font-weight-300" translate>Scan</h2>
                        </div>
                        <div class="card-body">
                            <form-domain-scan
                                [domain]="domain"
                                (basicAuthHostValidityChange)="updateScanAuthValidity($event)">
                            </form-domain-scan>
                        </div>
                    </div>
                </div>

                <!-- Features Section -->
                <div class="col-48 mt-3">
                    <div class="card panel-monsido-card" id="form_domain_features">
                        <div class="card-header">
                            <h2 class="font-weight-300" translate>Features</h2>
                        </div>
                        <div class="card-body">
                            <form-domain-features
                                *ngIf="!loading"
                                [domain]="domain"
                                [form]="domainForm">
                            </form-domain-features>
                        </div>
                    </div>
                </div>

                <!-- Domain Groups Section -->
                <div class="col-48 mt-3" *ngIf="domain?.id && domain.id > 0">
                    <div class="card panel-monsido-card" id="form_domain_groups">
                        <div class="card-header">
                            <h2 class="font-weight-300" translate>Domain Groups</h2>
                        </div>
                        <div class="card-body">
                            <form-domain-groups
                                [domain]="domain"
                                (updateDomain)="refreshDomain()"
                                [progress]="progress">
                            </form-domain-groups>
                        </div>
                    </div>
                </div>

                <!-- Users Section -->
                <div class="col-48 mt-3">
                    <div class="card panel-monsido-card" id="form_domain_users">
                        <div class="card-header">
                            <h2 class="font-weight-300" translate>Users</h2>
                        </div>
                        <div class="card-body" ngModelGroup="users">
                            <form-domain-users [domain]="domain">
                            </form-domain-users>
                        </div>
                    </div>
                </div>
            </div>
        </mon-spinner>
    </div>

    <!-- Footer -->
    <div class="mon-dialog-footer text-right">
        <button type="submit"
                data-test="save-button"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: domain?.id ? 'domain-edit-save': 'domain-new-save', params: {title: domain?.title}}"
                class="btn btn-border-radius btn-secondary"
                [disabled]="domainForm.invalid || !isScanValid || !isCMSValid || isSaving"
                translate>
            Save
        </button>
    </div>
</form>
